import { Injectable } from '@angular/core';
import firebase from 'firebase/app';
import { AngularFireAuth } from "@angular/fire/auth";
import { environment } from '../../environments/environment'
import { Observable } from 'rxjs/Rx';
// import { DataService } from './data.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs/internal/observable/of';

import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomPopupComponent } from '../components/dialogs/custom-popup/custom-popup.component';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  user: firebase.User;
  constructor(
    public afAuth: AngularFireAuth, // Inject Firebase auth service
    private http: HttpClient,
    // public firebase: AngularFireAuth,
    // public dataService: DataService,
    private router: Router,
    private snackbar: MatSnackBar,
    private translate: TranslateService
  ) {
    this.afAuth.onAuthStateChanged((user) => {
      if (user) {
        this.user = user;
      }
      else {
        this.user = null;
      }
    })
  }

  // Sign in with Google
  GoogleAuth() {
    return this.AuthLogin(new firebase.auth.GoogleAuthProvider());
  }

  // Auth logic to run auth providers
  AuthLogin(provider) {
    return firebase.auth().signInWithPopup(provider)
      .then((result) => {
        var params = { email: result.user.email, id_token: null }
        this.login(params).subscribe(data => {
          if (data.email == 'not exist') {

            this.translate.get('alerts.user_login_error').subscribe((res: string) => {
              this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
            })

            this.logout();
          }
          else {
            localStorage.setItem('email', result.user.email);
            if ((data.role == 'superadmin') || (data.role == 'admin')) {
              this.router.navigateByUrl('/users', { skipLocationChange: false }).then(() => {
                window.location.reload();
              });
            }
            else {
              this.router.navigateByUrl('/welcome', { skipLocationChange: false }).then(() => {
                window.location.reload();
              });
            }
          }
        })
      }).catch((error) => {
        console.log(error)
      })
  }

  public async anonymousLogin() { 
    return await this.afAuth.signInAnonymously(); 
  }

  public getUser(): Promise<any> { 
    return this.afAuth.currentUser 
  }

  getIdToken() {
    if (this.user) {
      return this.user.getIdToken()
    }
    else {
      return of(null)
    }
  }

  login(params: any): Observable<any> {
    return this.http.post(`${environment.API_URL}/api/checkLogin`, params);
  }

  logoutWithoutGoingLogin() {
    firebase.auth().signOut().then(() => {
      localStorage.removeItem("email");
    }).catch((error) => {
      // An error happened.
    });

  }

  logout() {
    // localStorage.clear();
    // this.router.navigate(['/login']);
    // return this.firebase.signOut();
    firebase.auth().signOut().then(() => {
      // Sign-out successful.
      // localStorage.clear();
      localStorage.removeItem("email");
      this.router.navigate(['/login']);
    }).catch((error) => {
      // An error happened.
    });
  }

}